import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

import { SharedTranslocoModule } from '@schaeffler/transloco';

import { CostComponentSplitType } from '@cdba/shared/models';

@Component({
  selector: 'cdba-toggle-split-type-button',
  templateUrl: './toggle-split-type-button.component.html',
  imports: [MatButtonModule, SharedTranslocoModule],
})
export class ToggleSplitTypeButtonComponent implements OnInit {
  buttonKey: string;

  CostComponentSplitType = CostComponentSplitType;

  @Input() currentSplitType: CostComponentSplitType;
  @Output() toggleSplitType = new EventEmitter<void>();

  ngOnInit(): void {
    this.buttonKey =
      this.currentSplitType === CostComponentSplitType.MAIN
        ? 'showMore'
        : 'showLess';
  }
}
